import * as React from 'react';
import Avatar from '@mui/joy/Avatar';
import Chip from '@mui/joy/Chip';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import ButtonGroup from '@mui/joy/ButtonGroup';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import CardOverflow from '@mui/joy/CardOverflow';
import CardActions from '@mui/joy/CardActions';
import IconButton from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import SvgIcon from '@mui/joy/SvgIcon';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/joy/Tooltip';
import { additionalSx } from '@utils/additionalSx';

export default function ObjectRelationshipCard(props) {
  const hasTitle = props.hasOwnProperty('title');
  const isEmpty = props.empty && props.empty === true;
  const unpadded = !!props?.unpadded;

  return (
    <Card
      sx={theme => ({
        width: '100%',
        height: '100%',
        boxShadow: 'md',
        gap: 0,
        flex: 0,
        // position: 'sticky',
        // top: 'calc(41px + 64px + 1rem)',
        opacity: props.empty ? 0.6 : 1,
        '--joy-shadowOpacity': .08,//.18,
        '--joy-shadowChannel': props.error ? '165 24 24'  : theme.shadowChannel,
        '--joy-shadowRing': props.error ? `0 0 ${theme.palette.danger[600]}` :  theme.shadowRing,
        '--joy-shadow-md': 'var(--joy-shadowRing, 0 0 #000),0px 2px 8px -2px rgba(var(--joy-shadowChannel, 21 21 21) / var(--joy-shadowOpacity, 0.08)),0px 6px 12px -2px rgba(var(--joy-shadowChannel, 21 21 21) / var(--joy-shadowOpacity, 0.08))',
        '--Icon-color': 'currentColor',
        'svg': {
          verticalAlign: 'middle',
        },
        ...additionalSx(theme, props.sx),
        // ...props.sx ? props.sx(theme) : {},
      })}
    >
        {typeof props.title === 'string' && (
          <CardOverflow sx={theme => ({ backgroundColor: props.error ? theme.palette.danger[200] : theme.palette.background.level1 })}>
            <CardActions>
              <Typography sx={theme => ({flex: 1, fontWeight: '600', color: props.error ? theme.palette.danger[700] : theme.palette.text.secondary })}>{props.title}</Typography>
            </CardActions>
          </CardOverflow>
        )}
        {typeof props.title !== 'string' && <>{props.title}</>}
      <CardOverflow sx={theme => ({
        ...hasTitle && {
          overflowY: 'auto',
          scrollbarWidth: 'thin',
          // height: '100%',
          // minHeight: '100%',
          maxHeight: {
            md: 'var(--mm-card-height, calc(100vh - var(--Header-height) - 8rem))',// '80vh',//'20vw', // todo, make this dependant on screen size
          },
        },
        backgroundColor: props.error ? theme.palette.danger[50] : null,
        ...(unpadded ? {px: 0} : {}),
      })}>
        {isEmpty && (
          <CardContent sx={{ px: unpadded && 2 }}>
            <Typography fontSize={'sm'}>There is nothing to show.</Typography>
          </CardContent>
        )}
        {!isEmpty && (<>
        {unpadded && (<>{props.children}</>)}
        {!unpadded && (
        <CardContent>
           {/* sx={{ alignItems: 'center', textAlign: 'center' }} */}
          {props.children}
          {/* {props.type} */}
          {/* {JSON.stringify(props.options)} */}
        </CardContent>
        )}
        </>)}
      </CardOverflow>
    </Card>
  );
}
